import { Button } from "antd";

import { GamificationBalance } from "@app/shared/ui/GamificationBalance";

type Props = {
  onClick: () => void;
};

export const GamificationHeaderItem: React.FC<Props> = ({ onClick }) => {
  return (
    <Button
      type="primary"
      className="flex flex-center bg-blue-1 border-blue-2 h-fit br-xxs color-gray-8 p-8 flex gap-5 fw-500"
      onClick={onClick}
    >
      <GamificationBalance />
    </Button>
  );
};
